<template>
  <div class="create-space-wrapper">
    <div class="title">{{ $t('app.panels.createSpace.title') }}</div>
    <div class="separator"></div>
    <div class="subtitle">{{ $t('app.panels.createSpace.subtitle') }}</div>
    <VForm
      :callback="submit"
      :submitButton="{
        label: $t('other.actions.create'),
        class: 'm green',
      }"
      :otherButtons="[
        {
          label: $t('other.actions.cancel'),
          class: 'm secondary',
          '@click': () => emit('close'),
        }
      ]"
    >
    <template #form-body>
      <VField class="m" :label="$t('app.panels.createSpace.nameField.title')" :placeholder="$t('app.panels.createSpace.nameField.placeholder')" type="text" name="name" v-model="spaceName" rules="required|max:50|min:2"></VField>
    </template>
    </VForm>
  </div>
</template>

<script lang="ts" setup>
import VField from '@/components/global/VField.vue';
import VForm from '@/components/global/VForm.vue';
import { useCreateSpace } from '@/queries/space.query';
import { useToast } from 'vue-toastification';

const { t } = useI18n();
const toast = useToast();
const appStore = useAppStore();
const { mutateAsync: createSpace } = useCreateSpace();

const spaceName = ref('');

const emit = defineEmits(["close"]);

async function submit() {
   await createSpace({
    organisationId: appStore.currentOrganisationId,
    name: spaceName.value,
    imageId: undefined,
  }, {
    onSuccess: (data) => {
      toast.success(t('app.toasts.success'));
      emit('close');
    },
    onError: () => {
      toast.error(t('other.error.ERROR_UNKNOWN'));
    },
  });
}

</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.create-space-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;

  height: 100%;
  width: 100%;

  .title {
    font-size: 20px;
    font-weight: 700;
  }

  .subtitle {
    font-size: 14px;
    font-weight: 600;
  }

  .separator {
    width: 100%;
    height: 1px;
    background-color: var(--light-grey-color);
  }
}

</style>